import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { Sparkle, SpinnerGap, Star } from "@phosphor-icons/react";

export default function DreamsBoard() {
  const [sonhos, setSonhos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/sonhos");
        if (!cancelled) setSonhos((data.data || []).filter(s => s.Estado === "AB"));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading) return (
    <div className="flex items-center gap-2 text-[#978D78] py-12">
      <SpinnerGap size={20} className="animate-spin" /> A montar o teu Dream Board...
    </div>
  );

  if (sonhos.length === 0) {
    return (
      <div className="text-center py-16">
        <Sparkle size={42} weight="fill" className="text-[#6F4F1D]/60 mx-auto" />
        <p className="text-[#4B5563] mt-3">Ainda não tens sonhos para mostrar no board.</p>
        <Link to="/dreams/vision" className="inline-flex items-center gap-2 mt-5 px-5 py-2.5 rounded-full bg-[#6F4F1D] text-[#0F1829] font-semibold text-sm">
          Definir vida de sonho
        </Link>
      </div>
    );
  }

  // O 1º sonho é o mais próximo (queremos foto grande)
  const [first, ...rest] = sonhos;

  return (
    <div className="space-y-6 pb-12">
      <header>
        <p className="text-xs uppercase tracking-widest text-[#6F4F1D]/80">Visualização</p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">Dream <span className="text-[#6F4F1D]">Board</span></h1>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 auto-rows-[180px]">
        <DreamTile s={first} large />
        {rest.map(s => <DreamTile key={s.ID_Sonho} s={s} />)}
      </div>
    </div>
  );
}

function DreamTile({ s, large }) {
  const cls = large ? "sm:col-span-2 sm:row-span-2 lg:col-span-2 lg:row-span-2" : "";
  return (
    <div className={`relative rounded-2xl overflow-hidden border border-[#E6E1D6] group ${cls}`}
         data-testid={`board-${s.ID_Sonho}`}>
      {s.FotoSonhoUrl ? (
        <img src={s.FotoSonhoUrl} alt={s.Titulo} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-violet-700/40 to-fuchsia-700/40 flex items-center justify-center">
          <Star size={32} weight="fill" className="text-[#6F4F1D]/40" />
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4">
        <p className={`font-semibold leading-tight ${large ? "text-xl sm:text-2xl" : "text-sm"}`}>{s.Titulo}</p>
        {s.DataAlvo && (
          <p className="text-[10px] text-[#6F4F1D] mt-1">
            {new Date(s.DataAlvo).toLocaleDateString("pt-PT", { day: "2-digit", month: "short", year: "numeric" })}
          </p>
        )}
      </div>
    </div>
  );
}
